import { pharmacyClient } from "@/connect";

export const getSuppliers = async () => {
  const response = await pharmacyClient.listSuppliers({
    page: 1,
    pageSize: 1000,
  });
  return response.suppliers;
};

export const getPurchaseInvoices = async (
  page: number,
  pageSize: number,
  supplierId?: string
) => {
  return await pharmacyClient.listPurchaseInvoices({
    pageNumber: page,
    pageSize: pageSize,
    supplierId: supplierId,
  });
};